import http from "../http-common";
import {
  IVisitorExpensesCreateRequest,
  IMarketingReportResponse,
  IVisitorExpensesResponse,
  IVisitorExpensesUpdateRequest,
  IMarketingReportWeeklyResponse,
  IVisitorExpensesWeeklyCreateRequest,
} from "../types/MarketingReport";

const getMarketingReport = (startDate: string, endDate: string) => {
  return http.get<Array<IMarketingReportResponse>>(
    `/marketing-report/get-report?startDate=${startDate}&endDate=${endDate}`
  );
};

const getMarketingReportWeekly = (startDate: string, endDate: string) => {
  return http.get<Array<IMarketingReportWeeklyResponse>>(
    `/marketing-report/get-report-weekly?startDate=${startDate}&endDate=${endDate}`
  );
};

const getVisitorAndExpenses = (startDate: string, endDate: string) => {
  return http.get<Array<IVisitorExpensesResponse>>(
    `/marketing-report/get-visitor-expenses?startDate=${startDate}&endDate=${endDate}`
  );
};

const getVisitorAndExpensesWeekly = (startDate: string, endDate: string) => {
  return http.get<Array<IVisitorExpensesResponse>>(
    `/marketing-report/get-visitor-expenses-weekly?startDate=${startDate}&endDate=${endDate}`
  );
};

const createVisitorAndExpenses = (request: IVisitorExpensesCreateRequest) => {
  return http.post<Array<IMarketingReportResponse>>(
    `/marketing-report/generate-report`,
    request
  );
};

const createVisitorAndExpensesWeekly = (
  request: IVisitorExpensesWeeklyCreateRequest
) => {
  return http.post<Array<IMarketingReportWeeklyResponse>>(
    `/marketing-report/generate-weekly-report`,
    request
  );
};

const updateVisitorAndExpenses = (
  request: IVisitorExpensesUpdateRequest,
  id: number
) => {
  return http.put<Array<any>>(
    `/marketing-report/update-visitor-expenses/${id}`,
    request
  );
};

const updateVisitorAndExpensesWeekly = (
  request: IVisitorExpensesUpdateRequest,
  id: number
) =>
  http.put<Array<any>>(
    `/marketing-report/update-visitor-expenses-weekly/${id}`,
    request
  );

const MarketingReportService = {
  getMarketingReport,
  getVisitorAndExpenses,
  createVisitorAndExpenses,
  updateVisitorAndExpenses,
  getMarketingReportWeekly,
  getVisitorAndExpensesWeekly,
  createVisitorAndExpensesWeekly,
  updateVisitorAndExpensesWeekly,
};

export default MarketingReportService;
